import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { API_ENDPOINT } from '../constants';
import { Channel, GoonAPIClient } from '../client/ApiClient';

const api = new GoonAPIClient(API_ENDPOINT);

@customElement('index-content')
export class IndexContent extends LitElement {
  createRenderRoot() { return this }

  @state()
  hotChannels: Channel[] = [];

  async connectedCallback() {
    super.connectedCallback();
    try {
      const user = await api.getCurrentUserProfile();
      if (user.id) {
        window.location.href = '/channels';
      }
    } catch { }

    try {
      const res = await api.getHotChannels();
      this.hotChannels = res.channels;
    } catch (err) {
      console.error('Failed to load hot channels', err);
    }
  }

  render() {
    return html`
      <div>
        <!-- Hero Section -->
        <section class="relative min-h-screen bg-cover bg-center text-white" style="background-image: url('/images/gogram-hero.jpg')">
          <div class="absolute inset-0 bg-gradient-to-r lg:from-black/50 from-[#9966CC] via-primary/70 to-primary"></div>
          <div class="relative z-10 container mx-auto px-4 sm:px-6 lg:px-20 py-8 lg:py-24 flex flex-col lg:flex-row items-center justify-between gap-12">
            <!-- Left: Copy -->
            <div class="w-full lg:max-w-2xl space-y-8 text-center lg:text-left">
              <h1 class="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight drop-shadow-md">Connect with Gooners and Goonettes</h1>
              <p class="text-lg sm:text-xl lg:text-2xl font-medium opacity-90">Gooning is more fun together! Discover content, chat, and express your tastes.</p>
              <ul class="space-y-4 text-base sm:text-lg">
                <li class="flex items-start justify-center lg:justify-start gap-3">
                  <span class="text-pink-300 text-xl leading-none">✔</span>
                  <span>Stay anonymous with fully private accounts</span>
                </li>
                <li class="flex items-start justify-center lg:justify-start gap-3">
                  <span class="text-pink-300 text-xl leading-none">✔</span>
                  <span>Connect and share content in GoonGram Channels</span>
                </li>
                <li class="flex items-start justify-center lg:justify-start gap-3">
                  <span class="text-pink-300 text-xl leading-none">✔</span>
                  <span>Express yourself with "Goonsonas"</span>
                </li>
                <li class="items-start justify-center lg:justify-start gap-3 flex">
                  <span class="text-pink-300 text-xl leading-none">✔</span>
                  <span>All (legal) tastes, kinks, and fetishes welcome</span>
                </li>
                <li class="items-start justify-center lg:justify-start gap-3 hidden lg:flex">
                  <span class="text-pink-300 text-xl leading-none">✔</span>
                  <span>Discover trending content</span>
                </li>
                <li class="flex items-start justify-center lg:justify-start gap-3">
                  <span class="text-pink-300 text-xl leading-none">✔</span>
                  <span>Create compilations and original content with GoonGram Content Tools</span>
                </li>
              </ul>
            </div>

            <!-- Right: Signup -->
            <div class="w-full max-w-md bg-white/90 text-gray-900 p-6 sm:p-8 rounded-2xl shadow-2xl backdrop-blur-sm">
              <h2 class="text-xl sm:text-2xl font-bold mb-6 text-primary text-center">Create An Account To Join</h2>
              <signup-component></signup-component>
            </div>

            <!-- Call to explore content -->
          </div>
          <div class="relative z-10 text-center mt-8">
            <p class="text-base sm:text-lg font-medium text-white/80">Not ready to sign up?</p>
            <p class="text-lg sm:text-xl font-semibold text-white">Check out the latest posts in top channels</p>
            <div class="mt-4 animate-bounce">
              <svg class="w-6 sm:w-8 h-6 sm:h-8 mx-auto text-white" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

        </section>

        <!-- Hot Posts Section -->
        <section class="py-20 sm:py-24 bg-base-100">
          <div class="container mx-auto px-4 sm:px-6 lg:px-20">
            <h2 class="text-3xl sm:text-4xl font-bold text-center text-secondary mb-12 sm:mb-16">Hot Posts</h2>

            <div class="flex flex-col gap-6 sm:gap-8">
              ${this.hotChannels.map(
                (channel) => html`
                  <channel-preview channelslug="${channel.slug}"></channel-preview>
                `
              )}
            </div>

            <div class="text-center mt-12 sm:mt-16">
              <a href="/channels" class="btn btn-lg btn-outline btn-secondary">
                Explore Channels
                <svg class="ml-2 w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </a>
            </div>
          </div>
        </section>
      </div>
    `;
  }
}

